module.exports = __webpack_public_path__ + "static/favicon-196x196-d0b823ac0b5cf378ac938fb563056697.png";